import * as React from 'react'
import LazyVideo from 'components/common/LazyVideo'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import HexPattern from 'components/common/HexPattern'

export default function HeroVideo({ title, _rawDescription, link, video }) {
	return (
		<section className="relative mx-auto grid max-w-screen-2xl items-center md:grid-cols-2">
			{video?.url ? (
				<figure className="bg-suede-black p-8">
					<iframe
						className="aspect-video w-full"
						src={video.url}
						title={title}
					/>
				</figure>
			) : (
				video && (
					<figure className="grid place-content-center self-stretch">
						<LazyVideo
							{...video}
							className="aspect-square"
							btnClassName="!right-auto !top-auto !w-auto m-8 text-xs"
						/>
					</figure>
				)
			)}

			<div className="relative z-[1] grid max-w-[600px] gap-8 bg-ft-gray-light/80 p-12 md:my-8 md:-translate-x-20 <md:!order-1 <md:m-4 <md:px-8">
				<h2 className="h1">{title}</h2>
				<SanityBlock body={_rawDescription} />
				<CTALink {...link} />
			</div>

			<HexPattern className="md:bottom-8 md:right-0 md:-scale-x-100 <md:bottom-0 <md:left-0" />
		</section>
	)
}
